const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost';

export const GetClassroomLayout = async (idAula: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/aula/${idAula}/layout`);
        if (!response.ok) return {};
        const data = await response.json();
        return data || {};
    } catch (error) {
        console.error('Error al obtener classroom layout:', error);
        return {};
    }
};

export const PostClassroomLayout = async (idAula: string | number, layout: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/aula/${idAula}/layout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(layout)
        });
        return response.ok;
    } catch (error) {
        console.error('Error al guardar classroom layout:', error);
        return false;
    }
};
